import { EmployeeCompensationLineItem } from "@/pages/employees/employee/components/EmployeeCompensationLineItem.tsx";
import { useCompensationComponents } from "@/queries/use-compensation-components.query.ts";
import { ApiFormResultCompensationLine } from "@/types/forms/form.types.ts";
import { Stack, Text } from "@skailer-com/uikit";

export function CompensationLinesValue({
  lines,
}: {
  lines: ApiFormResultCompensationLine[] | null | undefined;
}) {
  const { data: components = [] } = useCompensationComponents(Boolean(lines?.length));

  if (!lines?.length) return <Text>-</Text>;

  return (
    <Stack gap="sm">
      {lines.map((line, index) => (
        <EmployeeCompensationLineItem
          key={`${line.id ?? "new"}-${index}`}
          line={{
            id: line.id ?? undefined,
            compensation_component_id: line.compensation_component_id,
            amount_gross: line.amount_gross,
            amount_net: line.amount_net,
            currency_code: line.currency_code,
            per_type: line.per_type,
            sort: line.sort,
            description: line.description,
          }}
          component={components.find((item) => item.id === line.compensation_component_id)}
        />
      ))}
    </Stack>
  );
}
